var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4697 0.46967C16.7626 0.176777 17.2375 0.176777 17.5304 0.46967C17.8233 0.762563 17.8233 1.23744 17.5304 1.53033L6.53036 12.5303C6.26013 12.8006 5.82992 12.8244 5.53151 12.5857L0.531506 8.58565C0.20806 8.32689 0.155619 7.85493 0.414376 7.53148C0.673133 7.20803 1.1451 7.15559 1.46855 7.41435L5.94437 10.995L16.4697 0.46967Z",
    fill: "#3D6FB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.cb1466e62fbdfc16ed9e04ce25148804.svg";
export { ForwardRef as ReactComponent };